<template>
  <v-container  v-if="!showBookSummary" fluid class="content-container">
    <v-layout row wrap>
      <v-flex md6>
        <div class="heading then-card">Book Summary</div>
        <template v-if="promptAnswers['summarize']">
          <prompt :prompt="findPrompt('summarize')" :answer="promptAnswers['summarize']"></prompt>
        </template>

        <template v-if="promptAnswers['unique']">
          <prompt :prompt="findPrompt('unique')" :answer="promptAnswers['unique']"></prompt>
        </template>

        <template v-if="promptAnswers['exerpts']">
          <prompt :prompt="findPrompt('exerpts')" :answer="promptAnswers['exerpts']"></prompt>
        </template>

        <template v-if="promptAnswers['other_information']">
          <prompt
            :prompt="findPrompt('other_information')"
            :answer="promptAnswers['other_information']"
          ></prompt>
        </template>
      </v-flex>
      <v-flex md6>
        <div class="heading then-card">&nbsp;</div>
        <template v-if="promptAnswers['phrases']">
          <prompt :prompt="findPrompt('phrases')" :answer="promptAnswers['phrases']"></prompt>
        </template>

        <template v-if="promptAnswers['enjoy_most']">
          <prompt :prompt="findPrompt('enjoy_most')" :answer="promptAnswers['enjoy_most']"></prompt>
        </template>

        <template v-if="promptAnswers['fans_of']">
          <prompt :prompt="findPrompt('fans_of')" :answer="promptAnswers['fans_of']"></prompt>
        </template>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import Prompt from "./SummaryPrompt";

export default {
  name: "Summary",
  components: { Prompt },
  props: ["assignment"],
  data: function() {
    return {
      book: this.assignment.book,
      prompts: this.assignment.book.genre.summary_prompts,
      promptAnswers: this.assignment.book.summary[this.assignment.book.genre_id]
    };
  },
  computed: {
    imageUrl: function() {
      return process.env.VUE_APP_BOOK_IMAGES_PATH + this.book.id + ".jpg";
    },
    showBookSummary() {
      return isEmptyObject(this.promptAnswers)
    }
  },
  created() {
    // console.log("assignment", this.assignment);
    // console.log(isEmptyObject(this.promptAnswers))
    // console.log("prompts", this.prompts);
    // console.log(
    //   "promptAnswers",
    //   this.assignment.book.summary,
    //   this.assignment.book.genre_id,
    //   this.promptAnswers
    // );
  },
  methods: {
    findPrompt(name) {
      for (const p in this.prompts) {
        if (this.prompts[p].name === name) {
          return this.prompts[p];
        }
      }
    }
  }
};

function isEmptyObject(obj) {
  if (!obj) {
    return true;
  }
  return Object.values(obj).every(val => !val);
}
</script>

<style lang="scss" scoped>
.prompt {
  padding-bottom: 20px;
  font-family: $font-family;
}

.question {
  padding: 0.5em 0;
  font-size: 14.5pt;
  font-weight: 700;
  color: $color-blue;
}

.answer {
  padding-right: 60px;
  font-size: 13.5pt;
  line-height: 1.65em;
  font-weight: 500;
  text-align: left;
}

@media (max-width: 1024px) {
  .answer {
    padding-right: 0px !important;
  }
}
</style>


